import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { BlankSlate, Box } from '@factorialco/deprecated-design-system'

import Loading from 'modules/core/components/Loading'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import ImportEmployeesModal from 'modules/shift_management/components/ShiftManagement/ImportEmployeesModal'

import OnboardingBox from './OnboardingBox'

interface EmptyBodyProps {
  isLoading: boolean
}

const EmptyBody = ({ isLoading }: EmptyBodyProps) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const [openImportEmployeesModal, setOpenImportEmployeesModal] = React.useState<boolean>(false)

  const goToEmployees = () => {
    track(trackingEvents.shiftManagement.goToEmployees, { from: 'onboarding_shifts_button' })
    navigate(navigation.employees.fullPath())
  }

  const addEmployees = () => {
    track(trackingEvents.shiftManagement.importEmployeesStart, {
      location: 'start_menu',
    })
    setOpenImportEmployeesModal(true)
  }

  if (isLoading) return <Loading />

  return (
    <Box height="full" overflowY="scroll">
      {openImportEmployeesModal && (
        <ImportEmployeesModal onClose={() => setOpenImportEmployeesModal(false)} />
      )}
      <BlankSlate
        illustration="user-male-female"
        title={i18n.t('shift_management.empty_body.no_employees')}
        description={i18n.t('shift_management.empty_body.no_employees_description')}
      >
        <Box flexDirection="row" gap="s24" paddingTop="s64">
          <OnboardingBox
            icon="user-male-female"
            title={i18n.t('shift_management.empty_body.add_employees')}
            description={i18n.t('shift_management.empty_body.add_employees_description')}
            linkText={i18n.t('shift_management.empty_body.employees_section')}
            onClick={goToEmployees}
          />
          <OnboardingBox
            icon="time-planning"
            title={i18n.t('shift_management.empty_body.assign_employees')}
            description={i18n.t('shift_management.empty_body.assign_employees_description')}
            linkText={i18n.t('shift_management.empty_body.action')}
            onClick={addEmployees}
          />
        </Box>
      </BlankSlate>
    </Box>
  )
}

export default EmptyBody
